import React, { useState } from 'react';
import Navigation from './navigation';
import Footer from "./footer";
import { addSubscription } from "./subscriptionApi";

const Subscribe = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('');

    try {
      await addSubscription(formData);
      setMessage('Thank you for subscribing!');
      setMessageType('success');
      setFormData({ name: '', email: '' });
    } catch (error) {
      setMessage("Subscription failed. Please try again.");
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
          <div className="fixed top-0 left-0 right-0 z-50">
  <Navigation />
</div>
      <div className="hero-section2">
        <div className="page-title">Join Our Campaign</div>
      </div>
    
      <div className="contact-container">
        <div className="contact-card">
          <form className="contact-form" style={{padding: 20, marginTop: 30, marginBottom: 30}} onSubmit={handleSubmit}>
            <input 
              type="text" 
              name="name"
              placeholder="Your Name" 
              value={formData.name}
              onChange={handleChange}
              required 
            />
            <input 
              type="email" 
              name="email"
              placeholder="Your Email" 
              value={formData.email}
              onChange={handleChange}
              required 
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
            {message && (
              <div className={`message ${messageType}`} style={{
                padding: '10px',
                borderRadius: '5px',
                marginTop: '10px',
                textAlign: 'center',
                color: messageType === 'success' ? 'white' : 'white',
                backgroundColor: messageType === 'success' ? '#28a745' : '#dc3545'
              }}>
                {message}
              </div>
            )}
          </form>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Subscribe;
